import { ProductCardCompactSkeleton, Skeleton } from '@dustin-web/microsite-components/src/skeleton'

const InstantSearchMiniSkeleton = () => {
  return (
    <>
      <div className="u-px-16 u-pt-12 u-pb-8 d-flex">
        <Skeleton shade="dark" width={170} height={17}></Skeleton>
      </div>
      <ul className="ul-stripped u-mb-0">
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
      </ul>
      <ul className="ul-stripped u-mb-0">
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
        <li>
          <div className="u-px-16 u-py-12 d-flex">
            <Skeleton className="u-mr-16" shade="dark" width={16} height={16}></Skeleton>
            <Skeleton shade="dark" width={170} height={17}></Skeleton>
          </div>
        </li>
      </ul>
      <ul className="ul-stripped u-mb-0">
        <li>
          <ProductCardCompactSkeleton />
        </li>
        <li>
          <ProductCardCompactSkeleton />
        </li>
        <li>
          <ProductCardCompactSkeleton />
        </li>
      </ul>
    </>
  )
}

export default InstantSearchMiniSkeleton
